"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _List = _interopRequireDefault(require("@rsuite/icon-font/lib/application/List"));

// Generated by script, don't edit it please.
var List = (0, _createSvgIcon["default"])({
  as: _List["default"],
  ariaLabel: 'list',
  category: 'application',
  displayName: 'List'
});
var _default = List;
exports["default"] = _default;
module.exports = exports.default;